import { activateProductAnalytics } from "./activate-product-analytics";
import { getCookieConsent, getDefaultConsent, setCookieConsent } from "./consent";

export const grantProductAnalyticsConsent = (): void => {
  // Outside Europe with Global Privacy Control on, the regional default already grants
  // analytics and must keep ads denied, so storing "all" would override the signal.
  const keepsPrivacyControlDefault = getDefaultConsent()?.ads === false;
  if (getCookieConsent() !== "all" && !keepsPrivacyControlDefault) {
    setCookieConsent("all");
  }

  activateProductAnalytics();
};
